import React from 'react';
import PhilosophyArticle from './PhilosophyArticle';
import './PhilosophySection.css';

interface PhilosophyItem {
  id: string;
  icon: string;
  title: string;
  description: string;
}

interface PhilosophySectionProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  philosophyItems: PhilosophyItem[];
  className?: string;
}

const ROMAN_NUMERALS = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

const PhilosophySection: React.FC<PhilosophySectionProps> = ({
  eyebrow,
  title = "Investment Philosophy",
  subtitle,
  philosophyItems,
  className = ""
}) => {
  return (
    <section className={`philosophy-section ${className}`}>
      <div className="section-container">
        <div className="philosophy-content">
          {eyebrow && <div className="eyebrow centered">{eyebrow}</div>}
          <h2>{title}</h2>
          {subtitle && <p className="philosophy-subtitle">{subtitle}</p>}
          <div className="philosophy-charter">
            {philosophyItems.map((item, index) => (
              <PhilosophyArticle
                key={item.id}
                numeral={ROMAN_NUMERALS[index] || String(index + 1)}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
